var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternMultiline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10h4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14h4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternMultiline);
export default __webpack_public_path__ + "static/media/pattern-multiline.f58b01dcdaed6d3082247ae6d0624102.svg";
export { ForwardRef as ReactComponent };